import { Component, Input, OnInit } from '@angular/core';
import { VibrationsChart } from '../../models/charts/VibrationsChart';
import { CommonModule } from '@angular/common';
import { VibrationsChartChannel } from '../../models/charts/VibrationsChartChannel';
import { EventData } from '../../../features/vibration-events/models/event-data';
import { ControlPoint } from '../../models/controlPoint';
import { CurrentStateService } from '../../../core/services/current-state.service';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-record-history',
  imports: [CommonModule, TranslateModule],
  templateUrl: './record-history.component.html',
  styleUrl: './record-history.component.scss',
})
export class RecordHistoryComponent implements OnInit {

  constructor(private currentStateService: CurrentStateService,
    private router: Router) { }

  ngOnInit(): void {
    this.vibrationRecords = this.vibrationRecords.sort((a, b) => new Date(b.recordMetadata.timestamp).getTime() - new Date(a.recordMetadata.timestamp).getTime());
  }

  @Input() vibrationRecords: VibrationsChart[];
  @Input() controlPoints: ControlPoint[];
  @Input() events: EventData[];
  @Input() event: EventData;
  @Input() controlPoint: ControlPoint;
  @Input() siteId: number;
  @Input() eventId: number;
  @Input() controlPointId: number;
  selectedRecordIndex: number;

  public findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }

  getMaximumFrequency(channels: VibrationsChartChannel[]): number {
    return Math.max(...channels.map(channel => channel.frequencySpectrum.maximumFrequencyHz));
  }

  pascalToDecibel(pressure: number): number {
    const referencePressure = 20e-6;
    return 20 * Math.log10(pressure / referencePressure);
  }

  getControlPointName(controlPointId: number): string {
    if (this.controlPoint) {
      return this.controlPoint.name;
    }
    const controlPoint = this.controlPoints.find(cp => cp.controlPointId === controlPointId);
    return controlPoint ? controlPoint.name : '';
  }

  getEventName(eventId: number): string {
    if (this.event) {
      return this.event.name;
    }
    const event = this.events.find(cp => cp.id === eventId);
    return event ? event.name : '';
  }

  onRecordClick(record: VibrationsChart, selectedIndex: number) {
    this.selectedRecordIndex = selectedIndex;

    if (record.controlPointId && this.controlPoints) {
      const controlPoint = this.controlPoints.find(cp => cp.controlPointId === record.controlPointId);
      this.currentStateService.setCurrentControlPoint(controlPoint);
    }

    if (record.eventId && this.events) {
      const event = this.events.find(event => event.id === record.eventId);
      this.currentStateService.setCurrentEvent(event);
    }
  }

  onSeeRecordClick(recordId: number) {
    this.router.navigate(['/vibration-detail'],
      {
        queryParams:
          { recordId: recordId, siteId: this.siteId, eventId: this.event?.id, controlPointId: this.controlPoint?.controlPointId }
      });
  }
    getPicPPVFirstThree(record: VibrationsChart): number {
    const channels = record?.signalDataEntity?.signalData?.channels;
    if (channels?.length > 0) {
      const firstThree = channels.slice(0, 3);
      return Math.max(
        ...firstThree.map(channel =>
          this.findMaxAbsValue(channel.timeSpectrum.ppvMin, channel.timeSpectrum.ppvMax)
        )
      );
    }
    const meta = record?.recordMetadata;
    const ppvs = [meta?.verticalPpv, meta?.longitudinalPpv, meta?.transversePpv]
      .filter(v => v != null && !Number.isNaN(Number(v))) as number[];
    if (ppvs.length > 0) {
      return Math.max(...ppvs.map(v => Math.abs(v)));
    }
    return meta?.picVibration ?? 0;
  }

}
